import React, { useEffect, useState } from 'react';

import styled from 'styled-components';
import Autosuggest from 'react-bootstrap-autosuggest';
import debounce from 'lodash/debounce';

const StyledWrapper = styled.div`
  .dropdown-menu {
    max-height: 500px;
    overflow: auto;
  }
`;

const AutoCompleteSearch = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  styles,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  placeholder,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  datalist,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onComplete,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  itemValuePropName,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  clearOnSelect,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  initialText,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onTextChange,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  clearText,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  disabled,
}) => {
  const [text, setText] = useState(initialText || '');

  const onChange = debounce(str => {
    setText(str);
    if (onTextChange) onTextChange(str);
  }, 150);

  const onSelect = value => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    if (!datalist.includes(value)) return;
    if (onComplete) onComplete(value);
    if (clearOnSelect) {
      setText('');
    }
  };

  useEffect(() => {
    if (clearText) {
      onChange('');
    }
  }, [clearText]);

  return (
    <StyledWrapper style={styles}>
      <Autosuggest
        disabled={disabled}
        value={text}
        datalist={datalist}
        placeholder={placeholder || 'Start typing to select'}
        onSelect={onSelect}
        onChange={onChange}
        itemValuePropName={itemValuePropName}
      />
    </StyledWrapper>
  );
};

export default React.memo(AutoCompleteSearch);
